import { useEffect, useState } from 'react';

export const useChatBubble = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const checkVisibility = () => {
      // Use window.location instead of useLocation to avoid Router context issues
      const currentPath = window.location.pathname;

      // Hide chat bubble on profile pages
      const isProfilePage =
        currentPath.includes('/profile') ||
        currentPath.includes('/admin/profile');
      const isLoanFlowPage =
        currentPath === '/loan' || currentPath.startsWith('/loan/');

      setIsVisible(!isProfilePage && !isLoanFlowPage);
    };

    // Check on mount
    checkVisibility();

    // Listen for navigation changes
    const handlePopState = () => {
      checkVisibility();
    };

    // Listen for pushState/replaceState changes
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
      originalPushState.apply(history, args);
      setTimeout(checkVisibility, 0);
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(history, args);
      setTimeout(checkVisibility, 0);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  return { isVisible };
};
